import { render, staticRenderFns } from "./ChangeTariffModal.vue?vue&type=template&id=be0c1a44&scoped=true&lang=pug&"
import script from "./ChangeTariffModal.vue?vue&type=script&lang=js&"
export * from "./ChangeTariffModal.vue?vue&type=script&lang=js&"
import style0 from "./ChangeTariffModal.vue?vue&type=style&index=0&id=be0c1a44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be0c1a44",
  null
  
)

export default component.exports